import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import dialog from "./dialogreducers";
import selectedShoot from "./selectedshootreducers";
import auth from "./authreducer";
import dashboard from "./dashboardreducer";

export default history => {
  // console.log(history);
  return combineReducers({
    auth,
    router: connectRouter(history),
    dialog,
    selectedShoot,
    dashboard
  });
};
